import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./i18n";
import { useSeoMeta } from "@/hooks/useSeoMeta";
import { useEffect } from "react";

const RTL_LANGS = ["ar"];

function RtlDirectionManager() {
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    const updateDir = (lang: string) => {
      const isRtl = RTL_LANGS.includes(lang);
      document.documentElement.setAttribute("dir", isRtl ? "rtl" : "ltr");
      document.documentElement.setAttribute("lang", lang);
      document.documentElement.setAttribute("data-lang", lang);
    };

    updateDir(i18nInstance.language);

    const handleLangChange = (lang: string) => updateDir(lang);
    i18nInstance.on("languageChanged", handleLangChange);
    return () => {
      i18nInstance.off("languageChanged", handleLangChange);
    };
  }, [i18nInstance]);

  return null;
}

function SeoMetaUpdater() {
  useSeoMeta();
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <SeoMetaUpdater />
      <RtlDirectionManager />
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
